module.exports = __webpack_public_path__ + "img/country.4c59ab2f.svg";